/**
 * Lesson catalog — single source of truth for routing, copy and CTA targets
 * on /corso/lezione/:n. Imported by LessonPage and any helper hooks.
 *
 * Post-2026-07-02 funnel restructure:
 *   · L.1..L.4 are all free and auto-unlocked at registration.
 *   · CTA at end of L.1/L.2/L.3 = plain nav to the next lesson (no upsell).
 *   · CTA at end of L.4 = "Richiedi informazioni per sbloccare il resto"
 *     — opens the info-request dialog (same flow that used to live at end
 *     of L.1: consent → Meta CAPI Lead + WhatsApp drip + Make.com webhook).
 *   · L.5..L.9 unchanged (full_course purchase or admin unlock only).
 */
export const LESSON_META = {
  1: {
    title: "Lezione 1 · Non è un'emergenza: è un copione",
    eyebrow: "Lezione 1 di 9 · gratuita",
    nextCta: "Vai alla Lezione 2",
    nextHref: "/corso/lezione/2",
    upsellKind: "next_lesson",
    accessFlag: "has_access_l1",
    trackKey: "lesson_1",
  },
  2: {
    title: "Lezione 2 · Perché il copione ti trascina dentro",
    eyebrow: "Lezione 2 di 9 · gratuita",
    nextCta: "Vai alla Lezione 3",
    nextHref: "/corso/lezione/3",
    upsellKind: "next_lesson",
    accessFlag: "has_access_l2",
    trackKey: "lesson_2",
  },
  3: {
    title: "Lezione 3 · La cornice che decide cosa significa \"aiutare\"",
    eyebrow: "Lezione 3 di 9 · gratuita",
    nextCta: "Vai alla Lezione 4",
    nextHref: "/corso/lezione/4",
    upsellKind: "next_lesson",
    accessFlag: "has_access_l3",
    trackKey: "lesson_3",
  },
  4: {
    title: "Lezione 4 · Come evitare che il vecchio copione riprenda il controllo",
    eyebrow: "Lezione 4 di 9 · gratuita",
    // End of the free-access run. The CTA opens the info-request dialog
    // (same flow that used to fire at end of L.1) so the lead explicitly
    // requests to unlock L.5-L.9. No landing page — dialog only.
    nextCta: "Richiedi informazioni per sbloccare il resto del corso",
    nextHref: null,
    upsellKind: "request_info_rest_of_course",
    accessFlag: "has_access_l4",
    trackKey: "lesson_4",
  },
  5: { title: "Lezione 5 · Le insicurezze di tuo figlio", eyebrow: "Lezione 5 di 9", accessFlag: "has_access_full_course", trackKey: "lesson_5", isMembersOnly: true },
  6: { title: "Lezione 6 · Come dire no senza aprire una trattativa infinita", eyebrow: "Lezione 6 di 9", accessFlag: "has_access_full_course", trackKey: "lesson_6", isMembersOnly: true },
  7: { title: "Lezione 7 · La tua nuova identità", eyebrow: "Lezione 7 di 9", accessFlag: "has_access_full_course", trackKey: "lesson_7", isMembersOnly: true },
  8: { title: "Lezione 8 · Come risolvere definitivamente il problema", eyebrow: "Lezione 8 di 9", accessFlag: "has_access_full_course", trackKey: "lesson_8", isMembersOnly: true },
  9: { title: "Lezione 9 · Il protocollo", eyebrow: "Lezione 9 di 9", accessFlag: "has_access_full_course", trackKey: "lesson_9", isMembersOnly: true },
};

export const VIMEO_VIDEOS = {
  1: { id: "1202223180", h: "9abca017cb" },
  2: { id: "1202226751", h: "a4d2062c8c" },
  3: { id: "1202227040", h: "69ab89cca8" },
  4: { id: "1202227398", h: "fb71bbe178" },
  5: { id: "1202227397", h: "373ce41d36" },
  6: { id: "1202227396", h: "0bd1db4fe1" },
  7: { id: "1202227399", h: "69d56b4f6b" },
  8: { id: "1202227550", h: "fb46475f64" },
  9: { id: "1202227565", h: "1113d1c721" },
};

export const UPSELL_INFO = {
  upsell_lesson_3: { productName: "Lezione 3 — Neuroscienza Pratica", priceEur: 10.0 },
  // upsell_full_course intenzionalmente NON in lista: dopo L3 l'utente atterra
  // direttamente sulla Bridge (timer + offerta) e il "1 click" è il bottone della Bridge.
};
